<!-- <p>create-notification works!</p> -->
<div class="ceate-local-notification-container">
    <dl-edit-workflow (cancelBtnState)="onCloseBtnClicked($event)"></dl-edit-workflow>
    <dl-qn-sbn-side-navigation (updateBtnState)="onSideNavItemClicked($event)">
        <router-outlet sidecontent></router-outlet>
    </dl-qn-sbn-side-navigation>
    <dl-bottom-action-bar [btnState]="btnCurrentState" (stepButton)="onPrevNextBtnClicked($event)"></dl-bottom-action-bar>
</div>